import React from "react";
import { Button } from "../../../../Components/ui/button";

interface ApproveWithoutWelcomeDialogProps {
  open: boolean;
  message: string;   
  onClose: () => void;
  onConfirm: () => void;
}

const ApproveWithoutWelcomeDialog: React.FC<ApproveWithoutWelcomeDialogProps> = ({
  open,
  message,           // ← add this
  onClose,
  onConfirm,
}) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-black/30">
      <div className="bg-white rounded-xl p-6 w-full max-w-md border">
        <h2 className="text-lg font-semibold mb-6">
          {message}  {/* ← replace hardcoded text with dynamic message */}
        </h2>
        <div className="flex gap-4 justify-end">
          <Button
            variant="outline"
            className="border-red-500 text-red-500 hover:bg-red-500 hover:text-white"
            onClick={onClose}
            type="button"
          >
            No
          </Button>
          <Button
            className="bg-[#2563eb] text-white"
            onClick={onConfirm}
            type="button"
          >
            Yes
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ApproveWithoutWelcomeDialog;